export function adminFeedback(message: string, locale: string): string {
  if (/permission|insufficient|false for|Null value error/i.test(message)) {
    return locale === "ar"
      ? "تعذر الوصول إلى هذه البيانات. تحقق من حسابك وصلاحياتك ثم أعد المحاولة."
      : "This data could not be accessed. Check your account and permissions, then try again.";
  }
  if (/network|offline|unavailable|failed to fetch/i.test(message)) {
    return locale === "ar"
      ? "تعذر الاتصال الآن. تحقق من اتصالك ثم أعد المحاولة."
      : "Unable to connect right now. Check your connection and try again.";
  }
  return message;
}
